import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomRouterState } from './custom-route.model';

export const selectRouterState =
  createFeatureSelector<RouterReducerState<CustomRouterState>>('router');

export const selectCurrentRoute = createSelector(selectRouterState, router => router?.state);
